<template>
  <div v-if="!isSubscribe">
    <router-link
      :to="{ path: '/settings', query: { tab: 'billing' } }"
    >
      <div
        class="flex py-1.5 px-2.5 items-center gap-1 cursor-pointer hover:bg-won-bg-blue rounded-[6px]"
        :class="collapsed && 'justify-center'"
      >
        <svg fill="currentColor" v-if="!isSubscriptionModelActivated()" class="w-4 h-4" viewBox="0 0 16 17" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_647_30626)"><path d="M8.00004 1.83333C4.32004 1.83333 1.33337 4.82 1.33337 8.5C1.33337 12.18 4.32004 15.1667 8.00004 15.1667C11.68 15.1667 14.6667 12.18 14.6667 8.5C14.6667 4.82 11.68 1.83333 8.00004 1.83333ZM8.94004 12.56V13.8333H7.16004V12.5467C6.02004 12.3067 5.05337 11.5733 4.98004 10.28H6.28671C6.35337 10.98 6.83337 11.5267 8.05337 11.5267C9.36004 11.5267 9.65337 10.8733 9.65337 10.4667C9.65337 9.91333 9.36004 9.39333 7.87337 9.04C6.22004 8.64 5.08671 7.96 5.08671 6.59333C5.08671 5.44667 6.01337 4.7 7.16004 4.45333V3.16667H8.94004V4.46667C10.18 4.76667 10.8 5.70667 10.84 6.72667H9.53337C9.50004 5.98667 9.10671 5.48 8.05337 5.48C7.05337 5.48 6.45337 5.93333 6.45337 6.57333C6.45337 7.13333 6.88671 7.5 8.23337 7.84667C9.58004 8.19333 11.02 8.77333 11.02 10.4533C11.0134 11.6733 10.1 12.34 8.94004 12.56Z" fill="#8897AA"/></g><defs><clipPath id="clip0_647_30626"><rect width="16" height="16" fill="white" transform="translate(0 0.5)"/></clipPath></defs></svg>
        <svg v-else width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">            <g clip-path="url(#clip0_3798_34975)">            <path d="M10.6663 12.5V13.8333H5.33301V12.5H10.6663ZM7.33301 5.82663V11.1666H8.66634V5.82663H10.6663L7.99967 3.16663L5.33301 5.82663H7.33301Z" fill="#8897AA"/>            </g>            <defs>            <clipPath id="clip0_3798_34975">            <rect width="16" height="16" fill="white" transform="translate(0 0.5)"/>            </clipPath>            </defs>        </svg>
        
        <div
          v-if="!props.collapsed"
          class="text-sm font-medium ml-1 font-[Inter] text-won-gray-blue"
        >
          {{ !isSubscriptionModelActivated() ? 'Get more tokens' : 'Upgrade Plan' }}
        </div>
      </div>
    </router-link>
  </div>
</template>

<script setup>
import { useSubscriptionPlanStore } from "../../store/subscription.store";
import { isSubscriptionModelActivated } from '../../utils/helpers'
import { storeToRefs } from "pinia";

const props = defineProps({
  collapsed: {
    type: Boolean,
    default: false,
  },
})

const { isSubscribe } = storeToRefs(useSubscriptionPlanStore())
</script>
